export default {
	types: {
		video: 'Videos',
		book: 'Books',
		pdf: 'PDFs',
		post: 'Posts',
		image: 'Images',
		link: 'External links',
		file: 'Files',
	},
	emptyState: {
		title: 'No resources for this topic yet',
		body: 'Gather videos, articles and references to extend what you are studying.',
		collectCta: 'Gather resources',
	},
	viewer: {
		navigation: {
			label: 'Topic resources',
			previous: 'Previous resource',
			next: 'Next resource',
			position: '{{current}} of {{total}}',
		},
		onThisPage: 'On this page',
		backToTopic: 'Back to topic',
		extractionFailed: {
			title: 'We could not extract the content',
			description: 'Visit the original page to view the full content.',
		},
		openOriginal: 'Open original',
		pdf: {
			missingUrlTitle: 'PDF unavailable',
			missingUrlDescription:
				'We could not find a valid PDF URL for this resource.',
		},
		savedContent: {
			saveAction: 'Save content',
			saveFailed:
				'We could not save this content. Try again or open the original page.',
			notSavedTitle: 'Save it to read it here',
			notSavedDescription:
				'Use the bookmark to save this post into your course library and review it alongside the rest of the material.',
			saving: 'Saving content into your course library...',
			failedTitle: 'Content saved as a link',
			failedDescription:
				'We could not prepare the offline reading view for this post. You can open the original page or try again.',
			retry: 'Retry',
		},
	},
	images: {
		title: 'Images',
		titleWithTopic: 'Images · {{topicName}}',
		viewerTitle: 'Images · {{resourceTitle}}',
		dialogTitle: 'Images for {{topicName}}',
		dialogDescription:
			'Image {{current}} of {{total}}. Use the arrows to navigate.',
		counter: 'Image {{current}} of {{total}}',
		single: 'Image',
		imageSingular: 'image',
		imagePlural: 'images',
		more: 'more',
		untitled: 'Untitled',
		source: 'Source',
		viewOriginal: 'View original',
		deleteTitle: 'Delete image?',
		deleteDescription:
			'This action cannot be undone. The image will be permanently deleted.',
		noImages: 'There are no images in this resource',
		addImagesMessage: 'Images will appear here when they are added.',
	},
	operations: {
		resourceTypeTitle: {
			text: 'Text',
			post: 'Post/Article',
			pdf: 'PDF',
			video: 'Video',
			quiz: 'Quiz',
			api: 'API',
			unknown: '{{type}}',
		},
		summary: {
			noContent: 'No content',
			text: '{{summary}}',
			post: '{{summary}}',
			externalUrl: 'External URL: {{url}}',
			videoFromSource: 'Video from {{source}}: {{videoUrl}}',
			quizQuestions_one: 'Quiz with {{count}} question',
			quizQuestions_other: 'Quiz with {{count}} questions',
			apiEndpoint: 'API {{method}} {{endpoint}}',
			typeFallback: 'Resource of type {{type}}',
			error: 'Error getting resource information',
		},
	},
}
